import { Injectable } from '@angular/core';
import { DashboardAdminComponent } from "./dashboard-admin.component";

@Injectable()
export class DashboardAdminStyleService {
    constructor() { }

    public equalizeTopSectionCards() {
        var panel_column = $(".main-block-body .column");
        var panel_arr = [];
        // iterate through panels and get panels heights and put them in an array
        panel_column.each(function (i) {
            panel_arr[i] = $(this).height()
        });
        
        // return max of array of heights
        function max(arrayParameter) {
            var max = 0;
            for (var i = 0; i < arrayParameter.length; i++) {
                if (max < arrayParameter[i]) max = arrayParameter[i];
            }
            return max;
        }        
        var maxHeight = max(panel_arr);

        // iterate through panels and find card items and add necessary height to each one
        panel_column.each(function (i) {
            var numberOfCards = $(this).find(".card").length; // find how many card elements each panel_lg has
            var panelHeight = $(this).height();
            var addedHeight = (maxHeight - panelHeight) / numberOfCards; //  add this number to height of each card

            var cards = $(this).find(".card");
            // if it's the third column don't add height to first card
            if ($(this).hasClass('asf')) {
                // window width breakpoint from 3 columns to 2 columns and the third is below the 2
                if ($(window).width() > 1412) {
                    cards.each(function (i) {
                        if (i > 0) {
                            $(this).css("height", "+=" + (maxHeight - panelHeight) / (numberOfCards - 1) + "px");
                        }
                    });
                } else {
                    cards.each(function (i) {
                        $(this).css("height", "auto");
                    });
                }
            } else {
                // window width breakpoint from 2 columns to 1 column
                if ($(window).width() >= 960) {
                // add height to cards
                    cards.each(function (i) {
                        $(this).css("height", "+=" + addedHeight + "px");
                    });
                } else {
                    cards.each(function (i) {
                        $(this).css("height", "auto");
                    });
                }
            }
        })
    }

    public equalizeBottomSectionCards() {
        // return max of array of heights
        function max(arrayParameter) {
            var max = 0;
            for (var i = 0; i < arrayParameter.length; i++) {
                if (max < arrayParameter[i]) max = arrayParameter[i];
            }
            return max;
        }
        
        var panel_w = $(".main-block-body .panel_w3");
        var panel_arr2 = [];
        panel_w.each(function (i) {
            panel_arr2[i] = $(this).height()
        });

        // window width breakpoint from 3 columns to 1 column
        if ($(window).width() >= 1400) {
            var maxHeight2 = max(panel_arr2);
            panel_w.each(function (i) {
                var numberOfCards = $(this).find(".card").length; // find how many card elements each panel_lg has
                var panelHeight = $(this).height();
                var addedHeight = (maxHeight2 - panelHeight) / numberOfCards; //  add this number to height of each card

                var cards = $(this).find(".card");
                cards.each(function (i) {
                    $(this).css("height", "+=" + addedHeight + "px");
                });
            });
        } else {
            panel_w.each(function (i) {
                var cards = $(this).find(".card");
                cards.each(function (i) {
                    $(this).css("height", "auto");
                });
            });
        }
    }

    public initBxSlider() {
        if (DashboardAdminComponent.bxslider && typeof DashboardAdminComponent.bxslider.destroySlider === "function")
            DashboardAdminComponent.bxslider.destroySlider();
        DashboardAdminComponent.bxslider = $('.bxslider').bxSlider({
            nextSelector: '#slider-next',
            prevSelector: '#slider-prev',
            nextText: 'Next →',
            prevText: '← Prev',
            responsive: true
        });
    }

    public afterViewInit(firstPanelId: string, secondPanelId: string, self: any) {
        $(".ctrl-collapse").each(function () {
            $(this).on("click", function (event) {
                event.preventDefault();
                var sectionElement = $($($($($(this).parent()).parent()).parent()).parent()).find('div.panel-to-collapse');
                var target = '#' + $(sectionElement).attr("id");
                var svgButton = $(this).find("svg");
                var btnExpand = $(target).next(".ctrl-expand");
                $(target).toggleClass("closed");
                $(svgButton).toggleClass("turned");
                $(btnExpand).toggleClass("hidden");
                if (firstPanelId == target) {
                    self.topSectionUnSubscribeAutoRefresh();
                    if (!$(target).hasClass("closed"))
                        self.topSectionSubscribeToAutoRefresh();
                }
                if (secondPanelId == target) {
                    self.bottomSectionUnSubscribeAutoRefresh();
                    if (!$(target).hasClass("closed"))
                        self.bottomSectionSubscribeToAutoRefresh();
                }
            });
        });

        $("#publishers-select").treeMultiselect({ enableSelectAll: true, sortable: false });
        $("#providers-select").treeMultiselect({ enableSelectAll: true, sortable: false });
    }

}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-admin-style.service.ts